export function handlePubhubProjectPreviewRedirection(project/* site or doc */, projectID) {
    project.container.addEventListener("configDataError",function (e) {
        // if the pubhub preview url(e.g. /pubhub/site/447/new/) has been pushed to staging, 
        // the url will be redirected to url of staging(e.g. /site/security/)
        if(window.location.pathname.startsWith("/pubhub/") && e.detail.status == 404) {
            const prjData = Object.values(window["PUBHUB_PATH_LIST"]).find(i => i.id == projectID);
            if(prjData) {
                window.location = prjData.url;
            }
        }
    });
}